import React from 'react';

const TrackerInstanceSectionContext = React.createContext();

export default TrackerInstanceSectionContext;
